<template lang="pug">
  input(:value='value', number, type='number', ref='input',
    @input='updateValue($event.target.value)',
    :placeholder='placeholder',
    :min="minQuantity",
    :max='maxQuantity'
    @blur='formatValue'
  )
</template>

<script>
  export default {
    props: {
      placeholder: String,
      value: {
        type: [Number, null],
        default: null
      },

      minQuantity: {
        type: Number,
        default: 1
      },

      flagTop: {
        type: Boolean,
        default: true
      },

      maxQuantity: {
        type: [Number, null],
        default: null
      },

      decimal: {
        type: Boolean,
        default: true
      }
    },

    methods: {
      updateValue (value) {
        let newValue = null
        if (parseInt(value, 10)) {
          newValue = parseFloat((parseInt(value * 100, 10) / 100).toFixed(2))
        }

        if (!this.decimal) {
          newValue = Math.round(newValue, 10)
        }

        if (isNaN(newValue)) {
          newValue = this.minQuantity
        }

        if (this.maxQuantity !== null && this.flagTop && newValue > this.maxQuantity) {
          newValue = this.maxQuantity
        }

        this.$emit('input', newValue)
      },

      formatValue () {
        if (this.value === null || this.value < this.minQuantity) {
          this.$emit('input', this.minQuantity)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/shared/components/InputNumber.vue